<template>
  <div class="container">
    <h1>翻訳アイテムの作成</h1>
    <p>
      CKANからOrionへデータ連携する際に利用する日本語の変換テーブルへのアイテムの登録を以下より実施いただけます。<br />
      <b
        >英語については、英語小文字および数字、_（アンダースコア）のみ使うことが可能です。また、空白も利用することができません。<br />
        なお、入力された英語について上記の規則に則っていない場合には、自動的に変換するような仕組みになっております。</b
      >
    </p>
    <div class="table">
      <div class="alert">
        <v-alert
          v-model="alert"
          border="start"
          variant="tonal"
          closable
          close-label=""
          color="red-accent-4"
          title="登録に失敗しました。"
        >
          {{ alertMsg }}
        </v-alert>
      </div>
      <div class="alert">
        <v-alert
          v-model="success"
          border="start"
          variant="tonal"
          closable
          close-label=""
          color="green-accent-4"
          title="登録に成功しました。"
        >
          登録が完了しました。
        </v-alert>
      </div>
      <div class="itemSpace" v-for="n in itemCount" :key="n">
        <div class="item">
          <p>アイテム{{ n }} :</p>
          <v-text-field
            v-model="itemListJa[n - 1]"
            label="日本語"
          ></v-text-field>
          <v-text-field v-model="itemListEn[n - 1]" label="英語"></v-text-field>
          <v-icon
            icon="mdi-close"
            class="icon"
            @click="deleteItemTab(n - 1)"
          ></v-icon>
        </div>
      </div>
      <div class="item itemSpace">
        <v-btn @click="putItem()" :loading="loading">登録</v-btn>
        <v-btn @click="addItemTab()">タブの追加</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      alert: false,
      success: false,
      itemCount: 5,
      itemListJa: [null, null, null, null, null],
      itemListEn: [null, null, null, null, null],
      loading: false,
      alertMsg: "",
    };
  },
  methods: {
    addItemTab() {
      this.itemCount = this.itemCount + 1;
      this.itemListJa.push(null);
      this.itemListEn.push(null);
    },
    deleteItemTab(num) {
      this.itemListJa.splice(num, 1);
      this.itemListEn.splice(num, 1);
      this.itemCount = this.itemCount - 1;
    },
    putItem() {
      this.loading = true;
      let nullFlagJa = 0;
      for (let item in this.itemListJa) {
        if (this.itemListJa[item]) {
          console.log("");
        } else {
          nullFlagJa = nullFlagJa + 1;
        }
      }
      let nullFlagEn = 0;
      for (let item in this.itemListEn) {
        if (this.itemListEn[item]) {
          console.log("");
        } else {
          nullFlagEn = nullFlagEn + 1;
        }
      }
      if (nullFlagJa == 0) {
        if (nullFlagEn == 0) {
          axios
            .post(
              "https://api.dataplatform-yamanashi.jp/translate-table",
              {
                data: { jaList: this.itemListJa, enList: this.itemListEn },
              },
              { headers: { Authorization: "Bearer " + this.token } }
            )
            .then(() => {
              this.loading = false;
              this.alert = false;
              this.success = true;
            })
            .catch((error) => {
              console.log(error);
              this.alertMsg = error.response.data;
              this.loading = false;
              this.success = false;
              this.alert = true;
            });
        } else {
          this.alertMsg = "英語リストに値が入っていないフィールドがあります。";
          this.success = false;
          this.alert = true;
          this.loading = false;
        }
      } else {
        this.alertMsg = "日本語リストに値が入っていないフィールドがあります。";
        this.success = false;
        this.alert = true;
        this.loading = false;
      }
    },
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  margin: 36px 5%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.alert {
  width: 80%;
}

.item {
  width: 80%;
  display: flex;
  column-gap: 1vw;
  align-items: center;
  justify-content: center;
}

.itemSpace {
  margin-top: 20px;
}

.icon {
  cursor: pointer;
}
</style>
